import styled from "styled-components"

export const Input =  styled.input`
    width: 100%;
    height: 50px;
    margin: 0;
    padding: 0;
    background-color: var(--color-grey97);
    border: 1px solid var(--color-grey90);
    padding-left: 10px;
    &::placeholder {
        color: var(--color-grey45);
    }
`;

export const ContainerInput = styled.div`
    ${({error}) => {
        if(error){
            return (
            `
             input {
                border: 1px solid red;
                &::placeholder {
                    padding-left: 10px;
                }
             }
             p {
                visibility: visible;
             }
            `
            )
        }
    }}
    
`;

export const MsjError = styled.p`
    color: red; 
    visibility: hidden;
`;
export const TitleMsj = styled.span`
      font-weight: bold;
`;